<script>
export default {
  functional: true,
  name: 'development-tags',
  props: {
    tags: Array,
    badge: Boolean,
    inline: Boolean
  },
  render(h, { parent, props }) {
    const processedTags = props.tags
      .map(it =>
        parent.$t(`tags.${it}`) === `tags.${it}`
          ? it.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ')
          : parent.$t(`tags.${it}`)
      )

    let tags
    if (props.inline) {
      tags = <span>{ processedTags.join('    ') }</span>
    } else {
      tags = processedTags.map((tag, i) => <span key={i}>{ tag }</span>)
    }

    const classes = {
      'badge': props.badge,
      'inline': props.inline
    }

    return (
      <div class="development-tags">
        <h3>{ parent.$t('misc.developmentTagsTitle') }</h3>
        <div class={ classes }>
          { tags }
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss">
.development-tags {
  font-size: 1.1rem;
  line-height: 1.8rem;

  h3 {
    margin-bottom: 0.6em;
  }

  div {
    display: inline-flex;
    flex-wrap: wrap;

    span {
      border-radius: 20px;
      margin-right: 15px;
      margin-bottom: 8px;
      font-weight: normal;
      white-space: nowrap;
    }

    &.badge > span {
      background-color: #e8e7e9;
      padding: 0 0.6em;
      margin-right: 5px;
    }

    &.inline {
      flex-wrap: nowrap;
      width: 100%;

      & > span {
        white-space: pre;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
